<span
  class="tw:flex! underlined--{{ underlined }} size--{{ size }} color--{{ color }} {{
    className ? className : ''
  }} weight--{{ weight }}"
  [ngClass]="classNames"
  [class.disabled]="disabled"
  [class.bordered]="bordered"
  [class.tw:overflow-visible!]="!overflow"
  [style.-webkit-line-clamp]="maxLineClamp"
>
  <ng-content></ng-content>
</span>
